export default [
  { value: "", text: "Enter your level" },
  { value: "Year 1", text: "Year 1" },
  { value: "Year 2", text: "Year 2" },
  { value: "Year 3", text: "Year 3" },
  { value: "Year 4", text: "Year 4" },
  { value: "Year 5", text: "Year 5" }
];
